import 'bootstrap'; // Import Bootstrap JS
import Swiper from 'swiper'; // Import Swiper
import 'magnific-popup'; // Import Magnific Popup

const GalleryItemSlider = {
    _jGallerySwiper: null,
    _swiperGallaryObj: '',
    _thumbSwiper: '',
    _gallerySwiperObj: '',
    _sliderThumbEl: null,
    _sliderEl: null,
    _activeTabPane: null,

    init() {
        this._jGallerySwiper = $('.gallery__item_swiper');
        // this._sliderThumbEl = $(' .jsSwiper.jsgalleryThumb');
        // this._sliderEl = $('.jsSwiper.jsgallery');
        if (this._jGallerySwiper.length > 0) {
            this.initSlider();
        }
    },

    initSlider() {
        // Initialize Swiper for gallery items
        this._swiperGallaryObj = new Swiper(this._jGallerySwiper[0], {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: true,
            },
            scrollbar: {
                el: '.swiper-gallery-scrollbar',
                hide: false,
                draggable: true,
            },
            navigation: {
                nextEl: '.swiper-gallery-next',
                prevEl: '.swiper-gallery-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        });

        const showPopup = (slideId) => {
            $.magnificPopup.open({
                items: {
                    src: '#small-dialog',
                },
                type: 'inline',
                fixedContentPos: true,
                overflowY: 'hidden',
                callbacks: {
                    open: () => {
                        // Reset all tabs and content to inactive
                        $('.nav-link').removeClass('active').attr('aria-selected', 'false');
                        $('.tab-pane').removeClass('show active');

                        // Activate the correct tab and content based on the slide's id
                        const activeTab = $('.nav-link[href="#' + slideId + '"]');
                        activeTab.addClass('active').attr('aria-selected', 'true');
                        $('#' + slideId).addClass('show active');

                        // Initialize Swiper for the active tab content on popup open
                        this.initSwiperForActiveTab();
                    },
                },
            });
        };

        // Click event listener for each Swiper slide
        $('.gallery__item_swiper .swiper-slide').on('click', (event) => {
            const slideId = $(event.currentTarget).attr('id'); // Get the clicked slide's id
            showPopup(slideId); // Show the popup and activate the corresponding tab/content
        });

        // Handle tab switching (no 'e' parameter is used, so it's removed)
        $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', () => {
            this.initSwiperForActiveTab(); // Reinitialize Swiper for the active tab
        });
    },

    initSwiperForActiveTab() {
       this._activeTabPane = $('.tab-pane.show.active'); // Get the active tab's content

        this._sliderThumbEl = this._activeTabPane.find('.jsSwiper.jsgalleryThumb');
        this._sliderEl = this._activeTabPane.find('.jsSwiper.jsgallery');

        // Check if Swiper elements are available inside the active tab content
        if (this._sliderEl.length > 0 && this._sliderThumbEl.length > 0) {
            // Initialize thumbnail Swiper
            this._thumbSwiper = new Swiper(this._sliderThumbEl[0], {
                spaceBetween: 20,
                slidesPerView: 8,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });

            // Initialize main gallery Swiper
            this._gallerySwiperObj = new Swiper(this._sliderEl[0], {
                spaceBetween: 10,
                loop: true,
                autoplay: {
                    delay: 6000,
                },
                navigation: {
                    nextEl: '.swiper-gallery-thumb-next',
                    prevEl: '.swiper-gallery-thumb-prev',
                },
                thumbs: {
                    swiper: this._thumbSwiper,
                },
            });
        }
    },
};

export default GalleryItemSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_gallery-item-slider.js